import { isAnnotationLocked } from '../utils/annotationLockUtils';

export const ALIGN_SELECTED_ANNOTATIONS = 'ALIGN_SELECTED_ANNOTATIONS';

const annotationPatchChanged = (existing, patch) =>
  Object.keys(patch).some((key) => patch[key] !== existing[key]);

const alignSelectedAnnotations = (state, payload = {}) => {
  const { updates = [] } = payload;
  if (updates.length === 0) {
    return state;
  }

  let annotations = state.annotations;
  let changed = false;

  updates.forEach((update) => {
    const { id, ...patch } = update;
    const existing = annotations[id];
    if (!existing || isAnnotationLocked(existing) || Object.keys(patch).length === 0) {
      return;
    }
    if (!annotationPatchChanged(existing, patch)) {
      return;
    }
    if (!changed) {
      annotations = { ...state.annotations };
      changed = true;
    }
    annotations[id] = {
      ...existing,
      ...patch,
    };
  });

  if (!changed) {
    return state;
  }

  return {
    ...state,
    isDesignState: payload.isDesignState ?? true,
    annotations,
  };
};

export default alignSelectedAnnotations;
